<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal">×</button>
    <h4 class="modal-title">{{TR "Gesamtübersicht konfigurieren"}} {{deviceName}}</h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-sm-6 col-xs-12">
            <div class="row">
                <div class="col-sm-11 col-xs-12">
                    <label class="control-label">{{TR "Gerät"}}</label>
                    {{#SELECT selectedDevice}}
                    <select class="selectpicker js-devices" data-style="btn-white btn-sm" id="data_type_select-input" name="device_select">
                        {{#each devices}}
                        <option value="{{id}}">{{name}}</option>
                        {{/each}}
                    </select>
                   {{/SELECT}}
                </div>
            </div>
        </div>
    </div>

    <div class="m-t-10">
        <select multiple="multiple" class="multi-select js-values" id="value-multi-select" name="values_categories">
        {{#each valueGroups}}
            <optgroup label="{{name}}">
            {{#each values}}
                <option value="{{uniqueId}}" {{#if ../../showExtendedInfos}}sub_info="<small><span class='text-muted'>{{type}}_{{nr}} L{{length}} UC{{update_class}}</span></small>"{{/if}} {{VALUE_SELECTED ../../selectedValues this}}>{{TR_DATAPOINT_CATEGORY group name}}</option>
            {{/each}}
            </optgroup>
        {{/each}}
        </select>
    </div>
</div>

<div class="modal-footer">
    <button id="ct-cancel" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
    <button class="btn btn-primary" id="js-save">{{TR "Speichern"}}</button>
</div>

